<template>
  <modal id="update-billing-address" name="update-billing-address" :show="true" :closeable="true" @close="handleClose">
    <template #title>
      {{ this.trans('dashboard.update_billing_address.title') }}
    </template>
    <template #content>
      {{ this.trans('dashboard.update_billing_address.description') }}
      <loading-view :loading="loading" style="width: 600px;">
        <div class="mt-1">
          <div class="form_grid">
            <form-input id="address"
                        name="billing_address"
                        type="text"
                        v-model="form.billing_address"
                        container-class="form_group"
                        :label-text="trans('common.address')"
                        :error="form.errors.billing_address"
                        :placeholder="this.trans('common.address')"/>

            <form-input id="address-line-2"
                        name="billing_address_line_2"
                        type="text"
                        v-model="form.billing_address_line_2"
                        container-class="form_group"
                        :label-text="trans('common.address_line_2')"
                        :error="form.errors.billing_address_line_2"
                        :placeholder="this.trans('common.address_line_2')"/>
          </div>
          <div class="form_grid">
            <form-input id="zip"
                        name="billing_zip"
                        type="text"
                        v-model="form.billing_zip"
                        container-class="form_group"
                        :label-text="trans('common.postal_code')"
                        :error="form.errors.billing_zip"
                        :placeholder="this.trans('common.postal_code')"/>

            <form-input id="city"
                        name="billing_city"
                        type="text"
                        v-model="form.billing_city"
                        container-class="form_group"
                        :label-text="trans('common.city')"
                        :error="form.errors.billing_city"
                        :placeholder="this.trans('common.city')"/>
          </div>
          <div class="form_grid">
            <form-input id="state"
                        name="billing_state"
                        type="text"
                        v-model="form.billing_state"
                        container-class="form_group"
                        :label-text="trans('common.state')"
                        :error="form.errors.billing_state"
                        :placeholder="this.trans('common.state')"/>

            <form-input id="country"
                        name="billing_country"
                        type="select"
                        v-model="form.billing_country"
                        container-class="form_group"
                        :options="countries"
                        label="name"
                        track-by="code"
                        :label-text="trans('common.country')"
                        :error="form.errors.billing_country"/>
          </div>
        </div>
      </loading-view>
    </template>
    <template #footer>
      <div class="flex justify-content-end mt-4">
        <button class="button button_hollow" role="button" @click="handleClose">
          {{ trans('common.close') }}
        </button>
        <form-button
          role="button"
          :value="trans('common.update')"
          :disabled="loading || form.processing"
          :processing="form.processing"
          @click.prevent="update"/>
      </div>
    </template>
  </modal>
</template>

<script>
import {useForm} from "@inertiajs/vue3";
import FormButton from "@/components/Shared/Form/Button";
import FormInput from "@/components/Shared/Form/Input/Index";
import Modal from "@/components/Shared/Modal";

export default {
  name: "UpdateBillingAddressModal",

  components: {
    Modal,
    FormInput,
    FormButton
  },

  props: {
    user: Object
  },

  emits: ['close', 'valid'],

  data: () => ({
    loading: true,
    countries: [],
    form: useForm({
      billing_address: '',
      billing_address_line_2: '',
      billing_city: '',
      billing_zip: '',
      billing_state: '',
      billing_country: '',
    })
  }),

  async beforeMount() {
    await this.prepareCountries()
    this.prepareForm()

    this.loading = false
  },

  methods: {
    handleClose() {
      this.$emit('close')
    },

    handleValid() {
      this.$emit('valid')
    },

    update() {
      this.form
        .transform((data) => ({
          ...data,
          billing_country: data.billing_country?.code,
          redirect: false,
        }))
        .put(
          this.$route('dashboard.account.profile.billing_address.update'),
          {
            onSuccess: () => {
              this.handleValid()
              this.handleClose()
            }
          }
        )
    },

    prepareForm() {
      this.form.billing_address = this.user.billing_address
      this.form.billing_address_line_2 = this.user.billing_address_line_2
      this.form.billing_zip = this.user.billing_zip
      this.form.billing_city = this.user.billing_city
      this.form.billing_state = this.user.billing_state
      this.form.billing_country = this.countries.find((country) => country.code === this.user.billing_country)
    },

    async prepareCountries() {
      await axios.get('/countries').then(({data}) => {
        this.countries = data.data.countries;
      });
    },
  },
}
</script>
